import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import { setGlobalLoader } from "./apiLoader";
const DEFAULT_LOADING_TIME = import.meta.env.VITE_API_DEFAULT_LOADING_TIME;
console.log(`Default loading time: ${DEFAULT_LOADING_TIME}`);
// import  { t } from "i18next";
// import { toast } from "react-toastify";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  loadingTime?: number;
}

declare module 'axios' {
  interface AxiosRequestConfig {
    loadingTime?: number | null;
  }
}


const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // sends CloudFront signed cookies cross-origin
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosformdataInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // sends CloudFront signed cookies cross-origin
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
let loaderTimeout: ReturnType<typeof setTimeout> | null = null;


const addLoader = (customTimeout?: number) => {

  if (customTimeout === null) {
    return;
  }
  

  setGlobalLoader(true);
  if (loaderTimeout) clearTimeout(loaderTimeout);
  const timeout = customTimeout !== undefined ? customTimeout : DEFAULT_LOADING_TIME;

  if (timeout === 0) {
    
    return;
  }
  loaderTimeout = setTimeout(() => {
    
    setGlobalLoader(false);
  }, timeout);
};

// Request interceptor for axiosInstance
axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve the access token from localStorage or any other storage mechanism
    const token: any = Cookies.get("userToken");
    if (token) {
      // const accessToken = decryptToken(token);
      // Attach the token to the Authorization header
      config.headers.Authorization = `Bearer ${token}`;
    }
    const customTimeout = (config as CustomAxiosRequestConfig).loadingTime;
    addLoader(customTimeout);
    return config;
  },
  (error) => {
    // Handle errors during request setup
    setGlobalLoader(false); // Fallback
    return Promise.reject(error);
  }
);

// Add a request interceptor for axiosformdataInstance
axiosformdataInstance.interceptors.request.use(
  (config) => {
    // Retrieve the access token from cookies
    const token: any = Cookies.get("userToken");
    if (token) {
      // const accessToken = decryptToken(token);
      // Attach the token to the Authorization header
      config.headers.Authorization = `Bearer ${token}`;
    }
    const customTimeout = (config as CustomAxiosRequestConfig).loadingTime;
    addLoader(customTimeout);
    return config;
  },
  (error) => {
    // Handle errors during request setup
    setGlobalLoader(false); // Fallback
    return Promise.reject(error);
  }
);
// Add a response interceptor to handle token expiration or mismatch
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     let errorMessage = "";
//     let toastType: "error" | "warning" = "error"; // default to error

//     if (error.code === "ECONNABORTED") {
//       errorMessage =
//         t("request_timeout_try_again") ||
//         "Request timed out. Please try again.";
//     } else if (!error.response) {
//       errorMessage =
//         t("server_unreachable_or_wrong_base_url") || "server_not_reachable";
//     } else {
//       const { status, config, data } = error.response;

//       if (status === 404) {
//         if (config.url?.includes("animation-favorites/list-favorites")) {
//           errorMessage = t("no_favorites_selected") || "No favorites selected";
//           toastType = "warning"; //  show warning instead of error
//         } else {
//           errorMessage = t("page_not_found") || "Page not found";
//         }
//       } else if (status >= 500) {
//         errorMessage =
//           t("server_error_try_again") ||
//           "Server error. Please try again later.";
//       } else if (status === 401 || status === 403) {
//         errorMessage = t(data.message) || "Unauthorized access.";
//       } else {
//         errorMessage =
//           data?.message || t("unexpected_api_error") || "Unexpected error occurred.";
//       }
//     }

//     toast[toastType](errorMessage, {
//       position: "top-right",
//       autoClose: 3000,
//     });

//     return Promise.reject(error);
//   }
// );

axiosInstance.interceptors.response.use(
  (response) => {
    if (loaderTimeout) {
      clearTimeout(loaderTimeout);
      setGlobalLoader(false);
    }
    return response;
  },
  async (error) => {
    setGlobalLoader(false); // Always hide loader on error
    if (loaderTimeout) clearTimeout(loaderTimeout);

    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        console.error("Token expired or invalid. Redirecting to login...");
        // localStorage.removeItem("token"); // Remove expired token
        // window.location.href = "/login"; // Redirect to login page
      }
      if (status === 403 && data?.errorCode === "FREE_ACCESS_EXPIRED") {
        // Server-confirmed expiry from any API call - make it authoritative for
        // the existing localStorage-driven modal gate (authChecker.tsx) instead
        // of only trusting whatever was cached at last login.
        localStorage.setItem("viewAccess", "2");
        if (data.freeAccessExpiryDate) {
          localStorage.setItem("expiresOn", data.freeAccessExpiryDate);
        }
      }
    }
    return Promise.reject(error);
  }
);


// Optional: Add same response interceptor to axiosformdataInstance
axiosformdataInstance.interceptors.response.use(
  (response) => {
    if (loaderTimeout) {
      clearTimeout(loaderTimeout);
      setGlobalLoader(false);
    }
    return response;
  },
  (error) => {
    setGlobalLoader(false);
    if (loaderTimeout) clearTimeout(loaderTimeout);
    return Promise.reject(error);
  }
);

export const makeRequestWithCustomLoading = (requestConfig: any, loadingTime?: number) => {
  return axiosInstance({
    ...requestConfig,
    metadata: { loadingTime }
  });
};

export { axiosInstance, axiosformdataInstance };
